import axios from '../utils/axiosConfig';

const settingsAPI = {
  // Get all settings
  getSettings: async () => {
    const response = await axios.get('/settings');
    return response.data;
  },

  // Update notification settings
  updateNotificationSettings: async (settings) => {
    const response = await axios.put('/settings/notifications', settings);
    return response.data;
  },

  // Two-factor authentication
  setupTwoFactor: async () => {
    const response = await axios.post('/settings/2fa/setup');
    return response.data;
  },

  verifyTwoFactor: async (code) => {
    const response = await axios.post('/settings/2fa/verify', { code });
    return response.data;
  },

  disableTwoFactor: async (backupCode) => {
    const response = await axios.post('/settings/2fa/disable', { backupCode });
    return response.data;
  },

  // Session management
  getSessions: async () => {
    const response = await axios.get('/settings/sessions');
    return response.data;
  },

  revokeSession: async (sessionId) => {
    const response = await axios.delete(`/settings/sessions/${sessionId}`);
    return response.data;
  },

  revokeAllSessions: async (password) => {
    const response = await axios.post('/settings/sessions/revoke-all', { password });
    return response.data;
  },

  // Data management
  exportData: async () => {
    const response = await axios.get('/settings/export-data');
    return response.data;
  },

  requestAccountDeletion: async (password) => {
    const response = await axios.post('/settings/request-deletion', { password });
    return response.data;
  },

  // Reset settings
  resetSettings: async () => {
    const response = await axios.post('/settings/reset');
    return response.data;
  },
};

export default settingsAPI;